import { render, staticRenderFns } from "./ParasitList.vue?vue&type=template&id=1e4840fa&scoped=true&"
import script from "./ParasitList.vue?vue&type=script&lang=js&"
export * from "./ParasitList.vue?vue&type=script&lang=js&"
import style0 from "./ParasitList.vue?vue&type=style&index=0&id=1e4840fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4840fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VDataTable,VIcon})
